import { Fab, Typography } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined'
import useAccount from '@/presentation/hooks/auth/use-account'
import { i18nTranslationHelper } from '@/i18n'
import { useState, Fragment } from 'react'
import WhatsAppModal from '../modal/whatsapp-modal'

const FAB_BASE_STYLE = {
  position: 'fixed',
  bottom: 16,
  right: 16,
  zIndex: 999,
  display: 'flex',
  alignItems: 'center',
  gap: 1
} as const

const WHATSAPP_STYLE = {
  ...FAB_BASE_STYLE,
  backgroundColor: '#25D366',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#20b858'
  }
}

const WhatsAppButton = () => {
  const t = i18nTranslationHelper.getTComponents
  const [account] = useAccount()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { hasWhatsApp, redirectTo, whatsappPhone, companyName, hasChatBot, hasLink } =
    account?.helpCenterConfig || {}

  // Open link button when both WhatsApp and ChatBot are disabled
  if (!hasWhatsApp && !hasChatBot && hasLink) {
    return (
      <Fab
        sx={FAB_BASE_STYLE}
        aria-label={t('footer.helpButtonAriaLabel')}
        variant="extended"
        size="medium"
        color="primary"
        href={redirectTo}
        target="_blank"
        rel="noopener noreferrer"
        component="a"
      >
        <SupportAgentOutlinedIcon aria-hidden="true" />
        <Typography fontWeight={700} textTransform="none">
          {t('footer.helpTitle')}
        </Typography>
      </Fab>
    )
  }

  // Do not render WhatsApp button if WhatsApp is disabled or ChatBot is enabled
  if (!hasWhatsApp) return null
  if (hasChatBot) return null

  const handleWhatsAppClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  // Render WhatsApp button
  return (
    <Fragment>
      <Fab
        sx={WHATSAPP_STYLE}
        aria-label={t('whatsappButton.openModalAriaLabel')}
        aria-haspopup="dialog"
        aria-expanded={isModalOpen}
        aria-controls="whatsapp-modal"
        onClick={handleWhatsAppClick}
        variant="extended"
        size="medium"
        component="button"
        type="button"
      >
        <WhatsAppIcon aria-hidden="true" />
        <Typography fontWeight={700} textTransform="none" aria-hidden="true">
          {t('footer.helpTitle')}
        </Typography>
      </Fab>
      <WhatsAppModal
        open={isModalOpen}
        onClose={handleCloseModal}
        phoneNumber={whatsappPhone}
        companyName={companyName}
      />
    </Fragment>
  )
}

export default WhatsAppButton
